import React, { useEffect, useState } from 'react'
import SearchContainer from './SearchContainer'
import { Card, CardBody, Container } from 'reactstrap'
import ErrorBoundary from 'components/ErrorBoundary'
import Drawer from 'components/Drawer'
import AddCrosswalkDrawer from 'components/AddCrossWalk'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import useContextService from 'hooks/useContextService'
import useAxios from 'hooks/useAxios'
import { getUpdatedFilterLatest } from 'utils/helper'
import InventoryTable from './InventoryTable'
import { cloneDeep } from 'lodash'
import Loader from 'components/Loader'



let filters = [];
const Accumulations = (props) => {
  const API = useAxios();
  const { orgId } = props;
  //const { tenantID } = orgId.tenantID;
  // console.log(tenantID, 'tenantID');
  //console.log(orgId,"in purchase",window?.selectedOrganizationId)
  const [columnFilters, setColumnFilters] = useState([]);
 
  const {
    states: { inventory },
    setStates,
    resetStates
  } = useContextService();
  const [collapseSider, setcollapseSider] = useState(false);
  const [collIcon, setCollIcon] = useState(faAngleUp);
  const [isAccumulationsDetails, setIsAccmulationsDetails] = useState(false);
  const [isOpenGCN, setOpenGCN] = useState(false);
  const [data, setData] = useState([]);
  const [totalItem, setTotalItem] = useState(0);
  const [accRowData, setAccRowData] = useState({});
  const { search, coveredEntity, searchTerms, claimStatusID } = inventory;
    const [loading, setLoading] = useState(false);
    const [resetFilterFlag, SetResetFilterFlag]= useState(false);

  const toggleSider = () => {
    setcollapseSider(!collapseSider);
    if (!collapseSider) {
      setCollIcon(faAngleDown);
    }
    else {
      setCollIcon(faAngleUp);
    }
  }
  const toggleAccumulationsDetails = (rowData) => {
    setIsAccmulationsDetails(!isAccumulationsDetails);
    setAccRowData(rowData);
  };

  const toggleCrosswalkGCNDetais = () => {
    setOpenGCN(!isOpenGCN);
    // setDrawerPODetails('');
  };

  useEffect(() => {
    resetStates('inventory');
    onReset();
  }, [orgId]);

  const onReset = () => {
    debugger
    setcollapseSider(false);
    setData([]);
    setTotalItem(0);
    SetResetFilterFlag(true);
  };

  const onSearch = async (filter) => {
    debugger;
    const {
      CoveredEntityIDs,
      accumulationIds,
      ndc
    } = filter;
    // var ceIds = [];
    // if (CoveredEntityIDs === undefined && searchTerms.coveredEntityIDs.length !== undefined && searchTerms.coveredEntityIDs.length > 0) {
    //   ceIds = filter.coveredEntityIDs.map(item => item["value"]);
    //   ceIds = searchTerms.coveredEntityIDs;
    // }
    // else {
    //   ceIds = CoveredEntityIDs;
    // }

    if (ndc != '') {
      filters = getUpdatedFilterLatest('DrugID', ndc.toString(), filters);
    }
    else {
      var existNdc = filters.filter(c => c.filterName == "DrugID");
      if (existNdc != null)
        filters.pop(existNdc);
    }

    var acIds = [];
    if (accumulationIds === undefined && searchTerms.accumulationIDs.length !== undefined && searchTerms.accumulationIDs.length > 0) {
      acIds = filter.accumulationIDs.map(item => item["value"]);
    }
    else {
      acIds = accumulationIds;
    }

    const tableRes = document.querySelector('.table-responsive');
    tableRes.scrollLeft = 0;
    search.filters = filters;
    search.accumulationIds = acIds;
  //  search.ndc = filter.ndc
    // search.CoveredEntityIDs = ceIds;
    // console.log(tenantID, 'tenantid');
    await fetchAccumulatorData(search);

  };

  const fetchAccumulatorData = async (filters) => {
    debugger;
    if (!orgId?.tenantID) return null;
    if (window.selectedCoveredEntittyId == "" || window.selectedCoveredEntittyId == undefined) return null;
    let payload = {};
    // payload.CoveredEntityIDs = filters.CoveredEntityIDs,
    payload.AccumulatorIDs = filters.accumulationIds,
      payload.Filters = filters.filters;
    payload.CurrentPage = filters.currentPage
    payload.PageSize = filters.pageSize
    payload.OrderBy = filters.orderBy
    payload.Order = filters.order

    try {
      setLoading(true)
      const { data } = await API.post(`SBTenant/${orgId.tenantID}/Inventory/All`, payload, {
        hasDefaultURL: true,
        hideLoder: true,
      });
      if (data?.items?.length > 0) {
        // setcollapseSider(true);
        setCollIcon(faAngleDown);
        setData(data.items);
        setTotalItem(data.totalRecords);
      }
      else {        
        setData([]);
        setTotalItem(0);
      }
      setLoading(false);
    } catch (error) { }

  };
  const onPageChange = (filter, haveColFilter) => {
    updateInventorySearch(filter);
    if (haveColFilter) {
      const filterObj = cloneDeep(search);
      filterObj.filters = [...filterObj.filters, ...filter.filters];
      filterObj.currentPage = filter.currentPage;
      filterObj.pageSize = filter.pageSize;
      filterObj.orderBy= filter.orderBy;
      filterObj.order= filter.order;
      inventory.search = { ...inventory.search };
      fetchAccumulatorData(filterObj);
    } else {
      fetchAccumulatorData(filter);
      inventory.search = { ...inventory.search, ...filter };
    }
    setStates('inventory', inventory);
  };

  const updateInventorySearch = (filter) => {
      inventory.search.currentPage = filter.currentPage;
      inventory.search.pageSize = filter.pageSize;
      inventory.search.orderBy= filter.orderBy;
      inventory.search.order= filter.order;
  }

  const handleSearchColumnFilters = async (columnFilters) => {
    const filterObj = cloneDeep(search);
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
      setColumnFilters(columnFilters);
    }
    inventory.search.currentPage=1;
    filterObj.currentPage=1;
    await fetchAccumulatorData(filterObj);
  };

  const handleExport = async () => {
    debugger;
    const filterObj = cloneDeep(search);
    filterObj.AccumulatorIDs = filterObj.accumulationIds;
    delete filterObj.accumulationIds;
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
    }

    const { access_token } =
      JSON.parse(localStorage.getItem('pharmaforce')) || {};

      var additionalCriteria = {};
      additionalCriteria.IsSelectedColumn = false;
      additionalCriteria.OrgId = orgId.organizationID;
       // additionalCriteria.ContractId = 0;
    // additionalCriteria.POId = 0;
    // additionalCriteria.OpaId = 0;
    // additionalCriteria.CEId = 0;
    // additionalCriteria.ManufactureId = 0;

    var payload = {};
    payload.tenantID = orgId.tenantID
    payload.gridCode = "accumulation";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
  //  const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${orgId.tenantID}/Reports/ExportManufacturerAlls?access_token=${access_token}`;
  //  onExport(action, initialFilters);
  };

  const handleSearchColumnFiltersClear = () => {
    setColumnFilters([]);
  };

  const refetch = () => {
    setColumnFilters([]);
     inventory.search.currentPage=1;
    onSearch(searchTerms);
  };
  return (
    
    <div>
      {loading && <Loader></Loader>}

      <Container fluid className='width_info'>
      <div className={collapseSider ? "mb-0" : "mb-3"}>
        <Card className='border-0 shadow-top'>
          <CardBody hidden={collapseSider} className=''>
            <ErrorBoundary >
              <SearchContainer onSearch={onSearch} orgId={orgId} onReset={onReset} />
            </ErrorBoundary>
          </CardBody>
          </Card>
          </div>
          <Card className='border-0 shadow-top'>
          <CardBody>
            {/* <div className="py-0 text-center">
              <span style={{ fontSize: "27px", cursor: "pointer", }} onClick={toggleSider}>
                <FontAwesomeIcon icon={collIcon} className="fa-fw" />
              </span>
            </div> */}
            <ErrorBoundary >
              <InventoryTable
                tenantID={orgId}
                data={data}
                onExport={handleExport}
                filters={search}
              orgId={orgId}
                totalSize={totalItem}
                refetch={refetch}
                onPageChange={onPageChange}
                onSearchColumnFilters={handleSearchColumnFilters}
                onSearcgColumnFiltersClear={handleSearchColumnFiltersClear}
                searchTerms={searchTerms}
                toggleSider={toggleSider}
                collapseSider={collapseSider}
                resetFilterFlag={resetFilterFlag}
                SetResetFilterFlag={SetResetFilterFlag}
              />
            </ErrorBoundary>
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}

export default Accumulations
